import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-semi-circle',
  imports: [
    CommonModule,
  ],
  templateUrl: './semi-circle.component.html',
  styleUrl: './semi-circle.component.scss'
})
export class SemiCircleComponent implements OnInit, OnChanges {

  @Input() score: { domain: number[]; value: number } = { domain: [0, 100], value: 0 };
  @Input() delta: number = 0;
  @Input() min: number | null = null;
  @Input() max: number | null = null;
  @Input() colorScheme: any = null;

  gaugeMin = 0;
  gaugeMax = 100;
  gaugeValue = 0;
  gaugePercentage = 0;

  ngOnInit(): void {
    this.updateGaugeConfig();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['score'] || changes['min'] || changes['max'] || changes['colorScheme']) {
      this.updateGaugeConfig();
    }
  }

  updateGaugeConfig(): void {
    // Use provided min/max or default to score domain
    if (this.min !== null && this.max !== null) {
      this.gaugeMin = this.min;
      this.gaugeMax = this.max;
    } else if (this.score?.domain) {
      this.gaugeMin = this.score.domain[0];
      this.gaugeMax = this.score.domain[1];
    }

    this.gaugeValue = this.score?.value ?? 0;
    this.gaugePercentage = ((this.gaugeValue - this.gaugeMin) / (this.gaugeMax - this.gaugeMin)) * 100;
  }

  getScoreColor(): string {
    // Use blue color scheme to match the design
    if (this.gaugePercentage >= 70) return '#1976d2'; // Blue
    if (this.gaugePercentage >= 40) return '#42a5f5'; // Light Blue
    return '#90caf9'; // Lighter Blue
  }

  // getArcPath(): string {
  //   // Circle parameters matching the background arc
  //   // Background arc: M 20 100 A 80 80 0 0 1 180 100
  //   // This defines a semi-circle from (20, 100) to (180, 100) with radius 80
  //   const radius = 80;
    
  //   // Start point is always at the left side of semi-circle (same as background)
  //   const startX = 20;
  //   const startY = 100;
    
  //   // Calculate the end point based on percentage
  //   // The arc goes from left (0%) to right (100%) clockwise
  //   // Total arc length is 180 degrees
  //   const progressAngle = (this.gaugePercentage / 100) * 180; // Angle to cover (0 to 180 degrees)
    
  //   // Center of the circle for the semi-circle
  //   // The arc is the bottom half of a circle centered at (100, 100)
  //   // This creates a bottom half circle where:
  //   // - Start point (20, 100) is at angle 180° from center
  //   // - End point (180, 100) is at angle 0° from center
  //   const centerX = 100;
  //   const centerY = 100;
    
  //   // Calculate end point coordinates using the actual angles from center
  //   // Calculate the actual angles from center (100, 100) to the arc points
  //   const startAngleRad = Math.atan2(startY - centerY, startX - centerX);
  //   const fullEndAngleRad = Math.atan2(100 - centerY, 180 - centerX);
    
  //   // Calculate angle difference (clockwise from start to end)
  //   let angleDiff = startAngleRad - fullEndAngleRad;
  //   if (angleDiff < 0) angleDiff += 2 * Math.PI;
    
  //   // Calculate end angle based on percentage
  //   const calculatedEndAngleRad = startAngleRad - (progressAngle / 180) * angleDiff;
    
  //   // Calculate end point
  //   const endX = centerX + radius * Math.cos(calculatedEndAngleRad);
  //   const endY = centerY + radius * Math.sin(calculatedEndAngleRad);
    
  //   // For a semi-circle, we always use small arc (0) since we never exceed 180 degrees
  //   const largeArcFlag = 0;
    
  //   // Create the arc path - same format as background but with calculated end point
  //   // Both arcs start at (20, 100) and go clockwise (sweep flag = 1)
  //   // The progress arc overlaps the background, showing the filled portion
  //   return `M ${startX} ${startY} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endX} ${endY}`;
  // }

  getArcPath(percent: number): string {
    const cx = 100;
    const cy = 100;
    const r = 80;

    const startAngle = 180;
    const endAngle = 180 - (180 * percent / 100);
    const rad = (Math.PI / 180) * endAngle;

    const x = cx + r * Math.cos(rad);
    const y = cy - r * Math.sin(rad);

    return `M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${x} ${y}`;
  }
}